<div
  class="form-group mb-0"
  [ngbTooltip]="htmlTooltipContent"
  [disableTooltip]="!tooltip"
  [class]="wrapperClass"
  [tooltipClass]="tooltipClass"
>
  <div
    class="form-check custom-control custom-checkbox"
    [class.disabled-action]="disabled"
  >
    <input
      tabindex="-1"
      class="form-check-input custom-control-input"
      [class.pointer-cursor]="!disabled"
      type="checkbox"
      [id]="elementId"
      [name]="elementId"
      [ngModel]="isChecked"
      (change)="toggle($event)"
    />

    <label
      class="form-check-label custom-control-label"
      [class.pointer-cursor]="!disabled"
      [for]="elementId"
      [ngClass]="labelClass"
    >
      @if (iconClass) {
        <i
          class="me-1"
          [ngClass]="iconClass"
        ></i>
      }
      {{ content }}
    </label>
  </div>
</div>

<ng-template #htmlTooltipContent>
  <quill-view
    class="ql-editor-only-view"
    [content]="tooltip | translate"
  ></quill-view>
</ng-template>
